{
  "npBase": 30,
  "npPerVictimLevel": 0,
  "npLossFraction": 0.5,
  "npLevelGap": 10,
  "repeatVictimMs": 0,
  "ranks": [
    {
      "id": "skirmisher",
      "name": "Skirmisher",
      "minNp": 100
    },
    {
      "id": "blooded",
      "name": "Blooded",
      "minNp": 500
    },
    {
      "id": "veteran",
      "name": "Veteran",
      "minNp": 1500
    },
    {
      "id": "champion",
      "name": "Champion",
      "minNp": 5000
    },
    {
      "id": "paragon",
      "name": "Paragon",
      "minNp": 15000
    }
  ],
  "leaderboardSize": 50,
  "placeSymbols": [
    {
      "id": "sovereign",
      "name": "Sovereign",
      "upTo": 1
    },
    {
      "id": "exalted",
      "name": "Exalted",
      "upTo": 3
    },
    {
      "id": "vanguard",
      "name": "Vanguard",
      "upTo": 10
    },
    {
      "id": "warden",
      "name": "Warden",
      "upTo": 25
    },
    {
      "id": "sentinel",
      "name": "Sentinel",
      "upTo": 50
    }
  ],
  "placeRefreshMs": 60000,
  "championCloak": {
    "item": "whitecrown_mantle",
    "cloth": "#f2efe6",
    "trim": "#e8c050",
    "glow": "#fff2c0"
  },
  "rankRewards": [
    {
      "id": "champion_cloak",
      "item": "whitecrown_mantle",
      "ranking": "all",
      "place": 1
    }
  ]
}
